export default __webpack_public_path__ + "957be31be485fa765e2b15fda5b7acfd.svg";